import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Avatar, Row, Col, Button, DatePicker } from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import fileSaver from 'file-saver';
import Tab from '../Tab';
import Layout from '../Layout';
import CategoriesList from '../Categories/components/CategoriesList';
import TooltipTrimmed from '../../components/Tooltip/TooltipTrimmed';
import ErrorAlert from '../../components/ErrorAlert';
import { get, remove, resetState } from '../../modules/clients';
import { getClientsAsCSV } from "../../service/clients";

const { RangePicker } = DatePicker;

class ClientsTab extends Tab {
  columns = this.renderColumns();

  renderColumns() {
    return [
      { key: 'id', title: 'ID', dataIndex: 'id' }, {
        key: 'full_name',
        title: 'Name',
        dataIndex: 'full_name',
        render: (fullName, data) => {
          return (
            <Fragment>
              <Avatar
                size="large"
                src={data.logo}
                className="mr-1"
              />
              <Link to={`clients/${data.id}`}>{fullName}</Link>
            </Fragment>
          );
        },
      }, {
        key: 'phone_number', title: 'Phone', dataIndex: 'phone_number',
      }, {
        key: 'email',
        title: 'Email',
        dataIndex: 'email',
        render: (email) => <TooltipTrimmed str={email} maxLength={25}/>,
      }, {
        key: 'birthday',
        title: 'Birthday',
        dataIndex: 'birthday',
        render: (date) => {
          return (
            <span>{moment(date).format('YYYY-MM-DD')}</span>
          );
        },
      }, {
        key: 'categories',
        title: 'Categories',
        dataIndex: 'categories',
        render: (cat_name, data) => {
          return <CategoriesList catArray={data.categories} className="mb-minus-1"/>;
        },
      }, {
        key: 'cards_count',
        title: 'Cards count',
        dataIndex: 'cards_count',
        sorter: true,
      }, {
        key: 'friends_count',
        title: 'Friends count',
        dataIndex: 'friends_count',
        sorter: true,
      }, {
        key: 'leader_place',
        title: 'Leader place',
        dataIndex: 'leader_place',
        sorter: true,
      }, {
        key: 'created_at_range',
        title: 'Registered At',
        dataIndex: 'created_at',
        render: (created_at) => <span>{created_at ? moment(created_at).format('DD MMM Y, hh:mm A') : ''}</span>,
        sorter: true,
        filterDropdown: (props) => {
          const { setSelectedKeys, selectedKeys, confirm } = props;

          const defaultValue = Array.isArray(selectedKeys) && selectedKeys.length === 2
            ? selectedKeys.map(d => moment(d))
            : undefined

          return (
            <RangePicker
              defaultValue={defaultValue}
              ranges={{
                Today: [moment().startOf('day'), moment().endOf('day')],
                Yesterday: [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                'This Week': [moment().startOf('week'), moment().endOf('week')],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
              }}
              onChange={(range) => {
                range.length
                  ? setSelectedKeys([range[0].format(), range[1].format()])
                  : setSelectedKeys([]);
                confirm();
              }}
            />
          );
        }
      },
      this.tableActions(),
    ];
  }

  onParamsParseDone(state) {
    this.parseQuerySort(state, this.columns, 6);
    this.parseQuerySort(state, this.columns, 7);
    this.parseQuerySort(state, this.columns, 8);
    this.parseQuerySort(state, this.columns, 9);

    const createdAtFilter = state.filter && state.filter.created_at_range;
    if (createdAtFilter) {
      this.columns[9].defaultFilteredValue = createdAtFilter;
    }
  }

  exportClientsToCSV = async () => {
    const data = await getClientsAsCSV();
    const date = moment().format('LLL')
    const file = new File([data], `Clients (${date}).csv`, { type: "text/csv" });
    fileSaver.saveAs(file);
  }

  render() {
    return (
      <Layout>
        <ErrorAlert error={this.props.error}/>
        <Row justify='space-between' type='flex'>
          <Col>
            {this.renderFiltersBlock(this.renderSearchInput('search', 'search'))}
          </Col>
          <Col>
            <Button type="primary" onClick={this.exportClientsToCSV}>Export to CSV</Button>
          </Col>
        </Row>
        <Row>
          <Col>
            {this.renderDataTable()}
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.clients,
  }),
  {
    get, remove, resetState,
  })(ClientsTab);




// WEBPACK FOOTER //
// ./src/containers/Clients/ClientsTab.js